import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "uploader-container" }
const _hoisted_2 = { class: "uploader-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", null, "上传中", -1)
const _hoisted_4 = { class: "uploader-container" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileImageOutlined = _resolveComponent("FileImageOutlined")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_uploader = _resolveComponent("uploader")!

  return (_openBlock(), _createBlock(_component_uploader, {
    class: "styled-uploader",
    action: "/utils/upload-files",
    "show-upload-list": false,
    "before-upload": _ctx.commonUploadCheck,
    onSuccess: _cache[0] || (_cache[0] = 
      data => {
        _ctx.handleUploadSuccess(data.resp, data.file.raw)
      }
    )
  }, {
    loading: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LoadingOutlined, { spin: "" }),
        _hoisted_3
      ])
    ]),
    uploaded: _withCtx((dataProps) => [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showUploaded)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: dataProps.uploadedData.data.urls[0]
            }, null, 8, _hoisted_5))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_FileImageOutlined),
              _createElementVNode("h6", null, _toDisplayString(_ctx.text), 1)
            ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_FileImageOutlined),
          _createElementVNode("h6", null, _toDisplayString(_ctx.text), 1)
        ])
      ])
    ]),
    _: 3
  }, 8, ["before-upload"]))
}